import { Card } from '@/components/ui/Card'
import { Section, SectionHeading } from '@/components/ui/Section'
import { RegistrationForm } from '@/features/expedition/RegistrationForm'
import { NewsletterForm } from '@/features/subscribe/NewsletterForm'
import { useDocumentMeta } from '@/hooks/useDocumentMeta'
import { useI18n } from '@/i18n'

export function JoinPage() {
  const { t } = useI18n()
  useDocumentMeta({ title: t.join.heading, description: t.join.lead })

  return (
    <>
      <Section size="narrow">
        <SectionHeading eyebrow={t.join.eyebrow} title={t.join.heading} lead={t.join.lead} />
        <div className="mt-10">
          <RegistrationForm />
        </div>
      </Section>

      <Section className="hairline" size="narrow">
        <Card className="text-center sm:p-10">
          <h2 className="text-2xl sm:text-3xl">{t.join.newsletterHeading}</h2>
          <p className="mx-auto mt-3 max-w-md text-sm text-muted">{t.join.newsletterLead}</p>
          <div className="mx-auto mt-7 max-w-md">
            <NewsletterForm source="join-page" />
          </div>
        </Card>
      </Section>
    </>
  )
}
